export default __webpack_public_path__ + "static/11ty-5d164a67361473b4aad9b8afa7fb351c.svg";